function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "component", "className", "color", "width", "height"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import colors from "../../../design-system/scss/system/colors.module.scss";
import utilities from "../../../design-system/scss/system/utilities.module.scss";
import compose from "./compose";
import cls from "../../lib/cls";
import { componentType } from "../../lib/commonPropTypes";
import { jsx as _jsx } from "react/jsx-runtime";
var map = {
  'u-absolute': 'u-position-absolute'
};
var propMap = function propMap(v) {
  return map[v] || v;
};
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    component = _ref.component,
    className = _ref.className,
    color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = component;
  var imgProps = {};
  if (component !== 'img') {
    props.width = width;
    props.height = height;
  } else {
    imgProps.width = width;
    imgProps.height = height;
  }
  var classes = compose(props);
  var composedClasses = Object.values(classes).map(function (singleClass) {
    return utilities[singleClass];
  });
  var classNames = composedClasses.length ? cls(composedClasses) : '';
  var utilityKeys = Object.keys(utilities);
  var nonClasses = Object.entries(classes).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[1];
    return utilityKeys.indexOf(propMap(value.toString())) < 0;
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
      key = _ref5[0];
    return key;
  });
  var domProps = Object.entries(props).filter(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 1),
      key = _ref7[0];
    return nonClasses.indexOf(key) >= 0;
  });
  if (typeof children === 'function') {
    return children(classNames, Object.fromEntries(domProps), ref);
  }
  if (className && typeof className === 'string') {
    classNames += " ".concat(className);
  }
  if (color) {
    classNames += " ".concat(colors["palette--".concat(color)]);
  }
  classNames = classNames.trim();
  if (!classNames.length) {
    classNames = null;
  }
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, imgProps), Object.fromEntries(domProps)), {}, {
    className: classNames,
    children: children
  }));
});
Box.displayName = 'Box';
Box.defaultProps = {
  component: 'div',
  className: '',
  children: null,
  color: null
};
Box.propTypes = {
  component: componentType,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  color: PropTypes.string
};
export default Box;